import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-invitation-modal',
  templateUrl: './invitation-modal.component.html',
  styleUrls: ['./invitation-modal.component.css'],
})
export class InvitationModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
